/**
 * Picker schema for the /organizations/picker endpoint. Lean (3 fields) so
 * the TopNav OrgSelector dropdown stays snappy even on groups with many
 * orgs — mirrors the pickerAgentSchema pattern.
 */
import { z } from "zod";

export const pickerOrgSchema = z.object({
  org_id:   z.string(),
  name:     z.string(),
  // group_id is echoed by the server for defensive client-side filtering
  // when a group admin ever ends up with a stale picker payload cached
  // across a group switch. Harmless when all rows share the queried gid.
  group_id: z.string(),
});

export type PickerOrg = z.infer<typeof pickerOrgSchema>;

export const pickerOrgsSchema = z.array(pickerOrgSchema);
